import * as React from 'react';

import { observer } from 'mobx-react';

import { iconSetNames, SocialIconSet } from '@estee/elc-icons';
import { useSocialIconConfig } from '~utils/hooks/config';

interface ISocialIconProps {
    providerName: string;
    iconSetName?: iconSetNames;
}

export const SocialIcon = observer(({ providerName, iconSetName }: ISocialIconProps) => {
    const config = useSocialIconConfig(providerName);

    return <SocialIconSet name={providerName} iconSetName={iconSetName || config?.iconSetName} />;
});
